
"use strict";

/**
 * TODO - All this needs to change.  We don't need all the webs validations.  We have 2 forms with 1 input each.
 */
const jqueryPlaceholder = require("jquery-placeholder");
const jqueryValidation = require("jquery-validation/dist/jquery.validate");
const additionalMethods = require("jquery-validation/dist/additional-methods");
const $ = require("jquery");

let validationMessages = {
  "web.chat.email.Invalid" : "Please enter a valid email address",
  "web.chat.name.Invalid" : "Please use alphabetic characters only",
  "web.chat.message.Invalid" : "Please enter a message",
  "web.chat.pin.Invalid" : "Please enter a 5 digit numeric PIN"
};

let validationRegexes = {
  "email.address" : "^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$",
  "webChat.customerName" : "^[A-Za-z0-9-. ]{1,30}$",
  "webChat.pinNumber" : "^[0-9]{5}$"
};

// Store the old validation methods for delegation purposes
let $oldRequired = $.validator.methods.required;

/*
 * Initialises common jquery validation functions
 */
const initValidations = () => {
  console.log("Initialising webChat validations");
  applyPlaceholderTextToInputs();
  addRequiredValidator();
  addEmailAddressValidator();
  addWebChatCustomerNameValidator();
  addWebChatPinNumberValidator();
  loadValidations();

  console.log("Initialising webChat validations done.");
};

const applyPlaceholderTextToInputs = () => {
  $("input").placeholder();
};

/*
 * Prepares a validator for an email address
 */
const addEmailAddressValidator = () => {
  $.validator.addMethod(
    "webChatEmailAddress",
    (value, element, options) => {
      return validateField(value, "email.address", element);
    },
    (options) => {
      return getErrorMessage("emailAddress.Input.Invalid", options.errorKey);
    }
  );
};

/*
 * Replaces the in-built JQuery "required" validator to allow specification
 * of an error message key as part of the rule, which removes the need for a
 * separate "messages" section. It simply delegates onto the underlying
 * JQuery "required" function to do the actual validation work.
 */
const addRequiredValidator = function() {
  $.validator.addMethod(
    "webChatRequired", function (value, element, options) {
      if (shouldValidateField(element)) {
        console.log("required testing %s on element %s", value, element.id);
        let result = $oldRequired.call(this, value, element, options);
        console.log("result = %s", result);
        return result;
      }

      // No error
      return true;
    },
    (options) => {
      return getErrorMessage("required.field", options.errorKey);
    }
  );
};

/*
 * Prepares a validator for Web Chat Customer Name
 */
const addWebChatCustomerNameValidator = () => {
  $.validator.addMethod(
    "webChatFirstName",
    (value, element, options) => {
      return validateField(value, "webChat.customerName", element);
    },
    (options) => {
      return getErrorMessage("web.chat.name.Invalid", options.errorKey);
    }
  );
};

/*
 * Prepares a validator for Web Chat PIN Number (2FA)
 */
const addWebChatPinNumberValidator = () => {
  $.validator.addMethod(
    "webChatPinInput",
    (value, element, options) => {
      return validateField(value, "webChat.pinNumber", element);
    },
    (options) => {
      return getErrorMessage("web.chat.pin.Invalid", options.errorKey);
    }
  );
};

/*
 * Function to retrieve an error value based on the specified keys. It
 * returns the key used, if no value is found.
 *
 * @param fallbackMessageKey The fallback message key to use, for when the
 * errorMessage key is undefined. This is a required parameter.
 * @param errorMessageKey The error message key to use. This is an optional
 * parameter.
 */
const getErrorMessage = (fallbackMessageKey, errorMessageKey) => {
  console.log(
    "Error key = %s, default key = %s",
    errorMessageKey,
    fallbackMessageKey
  );

  let theKey = errorMessageKey ? errorMessageKey : fallbackMessageKey;

  return validationMessages[theKey] ? validationMessages[theKey] : theKey;
};

/*
 * Validates the specified value against the specified regular expression
 * @param value The value to test
 * @param regex The regexKey to validate against
 * @param element The element containing the value
 */
const validateField = (value, regexKey, element) => {
  console.log("Validating against %s on element '%s'", regexKey, element.id);

  if (shouldValidateField(element)) {
    let regex = new RegExp(validationRegexes[regexKey]);

    console.log("Validating against %s", regex);

    return regex.test(value);
  }

  return true;
};

/*
 * Loads the validation regexs and the validation messages for use with the
 * inline validation
 */
const loadValidations = () => {
  validationMessages = {
    "web.chat.email.Invalid" : "Please enter a valid email address",
    "web.chat.name.Invalid" : "Please use alphabetic characters only",
    "web.chat.message.Invalid" : "Please enter a message",
    "web.chat.pin.Invalid" : "Please enter a 5 digit numeric PIN"
  };
  validationRegexes = {
    "email.address" : "^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$",
    "webChat.customerName" : "^[A-Za-z0-9-. ]{1,30}$",
    "webChat.pinNumber" : "^[0-9]{5}$"
  };
};

/*
 * Check if the specified field should be validated.
 *
 * @return true if the field is visible, false otherwise. If the type is "hidden", we check the parent node (as a
 * hidden field will never be visible). An example of this is the "type-ahead county" field, where the validated
 * field is actually a hidden field.
 */
const shouldValidateField = (element) => {
  if (element.type === "hidden") {
    return isVisible(element.parentNode);
  }

  return isVisible(element);
};

/*
 * Function to test if the specified element is visible
 *
 * @param The element to test ("regular" JS object, not JQuery)
 */
const isVisible = (element) => {
  return $(element).is(":visible");
};

/**
 * Page init function that is called when the module is loaded
 */
const pageInitialisation = () => {
  initValidations();
};

module.exports = {
  pageInitialisation: pageInitialisation,
};